export const getFileNameFromSignedUrl = (signedUrl: string) => {
    const splitedUrl = signedUrl.split('?')[0].split('/')
    return splitedUrl[splitedUrl.length - 1]
  }

  export const getFileNameFromUrl = (url: string) => {
    return url.split('/').pop()
  }